export const HEADER_SESSION_ID = "x-session-id";

export function getChatbotSessionKey({
	chatbotId,
	isPreview,
}: {
	chatbotId: string;
	isPreview: boolean;
}) {
	return isPreview ? `VB_Session_Preview_${chatbotId}` : `VB_Session_${chatbotId}`;
}
